import { RouterModule, Routes } from '@angular/router';

import { IdentityVerificationPageComponent } from './identity-verification/identity-verification.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { NgModule } from '@angular/core';
import { RegistrationCompleteComponent } from './registration-complete/registration-complete.component';
import { SetAvatarComponent } from './set-avatar/set-avatar.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SetPhoneComponent } from './set-phone/set-phone.component';
import { SetPinComponent } from './set-pin/set-pin.component';
import { VerifyRecoveryPhoneComponent } from './verify-recovery-phone/verify-recovery-phone.component';
import { VerifyTwofactorPhoneComponent } from './verify-twofactor-phone/verify-twofactor-phone.component';
import { InvitationComponent } from './invitation/invitation.component';
import { InvitationExpiredComponent } from './invitation/invitation-expired/invitation-expired.component';
import { InvitationNotFoundComponent } from './invitation/invitation-not-found/invitation-not-found.component';

const routes: Routes = [
    {
        path: 'invitation/expired',
        component: InvitationExpiredComponent,
    },
    {
        path: 'invitation/not-found',
        component: InvitationNotFoundComponent,
    },
    {
        path: '',
        component: LoginLayoutComponent,
        children: [
            { path: '', component: LoginFormComponent },
            { path: 'set-password', component: SetPasswordComponent },
            { path: 'set-pin', component: SetPinComponent },
            { path: 'set-phone', component: SetPhoneComponent },
            { path: 'set-avatar', component: SetAvatarComponent },
            { path: 'identity-verification', component: IdentityVerificationPageComponent },
            { path: 'verify-recovery-phone', component: VerifyRecoveryPhoneComponent },
            { path: 'verify-twofactor-phone', component: VerifyTwofactorPhoneComponent },
            { path: 'registration-complete', component: RegistrationCompleteComponent },
            { path: 'invitation/:uuid', component: InvitationComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule { }
